<template>
  <v-col v-if="isChannelActive" cols="12" sm="6">
    <v-container :class="getChannelClass">
      <div :id="uniqueId" class="d-flex align-self-start message-container-sections justify-space-between">
        <div class="d-flex message-container-section-top">
          <mf-tooltip :disabled="!channelActivated" top max-width="300px">
            <template #activator>
              <mf-icon
                v-if="isManualPriority"
                :class="{ 'cursor-pointer': channelActivated }"
                :disabled="!channelActivated"
                :color="channelActivated ? 'marca-0-l40' : 'cinza-l20'"
                @click="toggleDropdown"
                >swap_vert</mf-icon
              >
              <span
                v-if="isManualPriority"
                :class="{ 'message-rank-number': true, 'cinza-l20--text': !channelActivated, 'marca-0-l40--text': channelActivated }"
              >
                {{ channel.priority }}
              </span>
            </template>
            Prioridade
          </mf-tooltip>
          <v-divider v-if="isManualPriority" vertical class="mx-2"></v-divider>
          <v-icon :color="channelActivated ? '#004D99' : '#87919b'" class="mr-2">{{ channel.icon }}</v-icon>
          <span v-if="channelActivated" class="message-rank">{{ channel.name }}</span>
          <span v-else class="message-rank cinza-l20--text">{{ channel.name }} | Canal inativado</span>
        </div>

        <mf-button
          v-if="displayMessage || displayMessageTitle"
          label="Detalhes do canal"
          color="marca-0-l20"
          outlined
          icon="arrow_forward"
          icon-position="right"
          :disabled="disabled"
          @click="goToDetails"
        ></mf-button>
      </div>
      <v-menu v-model="showDropdown" :disabled="disabled" :attach="`#${uniqueId}`" bottom origin="center center" transition="scale-transition" open-delay="2">
        <v-list>
          <v-list-item v-for="(n, index) in channelsWithMessage.length" :key="n" @click="changePriority(n)">
            <v-list-item-title>{{ index + 1 }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <div class="d-flex flex-column col-sm-4 col-lg-6 col-xl-7 channel-card" style="gap: 12px">
        <div class="d-flex">
          <channel-message-preview
            v-if="showEmailUnavailablePreview"
            :unavailable="true"
            :channel="mapChannelsNames[channel.name]"
            :offer-type="selectedOfferType"
          />
          <channel-message-preview
            v-else-if="displayMessage || displayMessageTitle"
            :message="displayMessage"
            :message-title="displayMessageTitle"
            :channel="mapChannelsNames[channel.name]"
            :offer-type="selectedOfferType"
            insert-best-offer-as-div
          />
        </div>
      </div>
      <div class="d-flex flex-column align-self-baseline">
        <div class="d-flex">
          <mf-tooltip v-if="isMariaCampaignActive" top>
            <template #activator>
              <mf-toggle v-model="channelActivated" hide-details />
            </template>
            {{ channelActivated ? 'Desativar canal' : 'Ativar canal' }}
          </mf-tooltip>
          <v-btn v-else icon small color="gray" :disabled="disabled" @click="cleanChannel"><mf-icon>delete</mf-icon></v-btn>
        </div>
      </div>
    </v-container>
  </v-col>
</template>

<script>
import channelsDefaultMessages from '@/modules/maria/helpers/maria-default-values'
import ChannelMessagePreview from './ChannelMessagePreview.vue'
import { channelsForm } from '@/modules/maria/campanha-da-maria-v2/mixins/channels-form'

let globalId = 0

export default {
  components: {
    ChannelMessagePreview,
  },
  mixins: [channelsForm],
  props: {
    channel: {
      type: Object,
      required: true,
    },
    channels: {
      type: Object,
      required: true,
    },
    isMariaCampaignActive: {
      type: Boolean,
      required: true,
    },
    isChannelActive: {
      type: Boolean,
      required: true,
    },
    isManualPriority: {
      type: Boolean,
      required: true,
    },
    settingsId: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      id: ++globalId,
      showDropdown: false,
    }
  },
  computed: {
    channelActivated: {
      set() {
        const updatedChannel = { ...this.channel, active: !this.channel.active }
        this.$emit('update-channel', updatedChannel)
      },
      get() {
        return this.channel.active
      },
    },
    uniqueId() {
      return `menu-for-${this.channel.icon}-${this.id}`
    },
    mapChannelsNames() {
      return {
        SMS: 'sms',
        'Push App': 'push',
        'E-mail': 'email',
        WhatsApp: 'whatsapp',
      }
    },
    displaySubject() {
      if (this.channel.name === 'E-mail') {
        return this.channel.message.subject
      }
      return this.channel.subject
    },
    displayMessage() {
      if (this.channel.name === 'E-mail') {
        if (this.channel?.message?.email_configuration_type === 'BUILDER') {
          return this.channel.message.processed_html
        }
        if (this.channel?.message?.email_configuration_type === 'SIMPLE') {
          return this.channel.message.simple_email_configuration?.text
        }
        if (this.channel?.message?.email_configuration_type === 'HTML') {
          return this.channel.message.html_email_configuration?.text || this.channel.message.processed_html
        }
      }
      return this.channel.message?.text
    },
    displayMessageTitle() {
      return this.channel.message.title || ''
    },
    channelsWithMessage() {
      return Object.values(this.channels).filter((channel) => {
        const msg = channel.message

        return (
          msg?.title ||
          msg?.text ||
          msg?.simple_email_configuration?.text ||
          msg?.html_email_configuration?.text ||
          msg?.processed_html ||
          Object.keys(msg?.builder_email_configuration || {}).length > 0
        )
      })
    },
    getChannelClass() {
      return {
        'message-container': true,
        'd-flex': true,
        'pa-5': true,
        'align-center': true,
        'justify-space-between': true,
        'inactive-channel': !this.channelActivated,
      }
    },
    showEmailUnavailablePreview() {
      return this.channel.name === 'E-mail' && ['BUILDER', 'HTML'].includes(this.channel?.message?.email_configuration_type)
    },
  },
  methods: {
    toggleDropdown() {
      if (!this.channelActivated) return

      this.showDropdown = !this.showDropdown
    },
    changePriority(newPriority) {
      const updatedChannel = { ...this.channel, priority: newPriority }
      const channelsKeys = Object.keys(this.channels)
      const swappedChannel = channelsKeys.find((channel) => this.channels[channel].priority === newPriority)
      if (swappedChannel) this.channels[swappedChannel].priority = this.channel.priority
      this.$emit('update-channel', updatedChannel)
      this.showDropdown = false
    },
    async cleanChannel() {
      const confirmed = await this.$confirm({
        message: 'Tem certeza que deseja limpar as configurações do canal?',
        confirmText: 'Limpar',
        cancelText: 'Cancelar',
        confirmColor: 'vermelho-d20',
      })
        .then(() => true)
        .catch(() => false)

      if (confirmed) {
        const updatedChannel = { ...this.channel, message: channelsDefaultMessages[this.mapChannelsNames[this.channel.name]], active: false, priority: '' }
        this.$emit('update-channel', updatedChannel)
      }
    },
    goToDetails() {
      const channelName = this.mapChannelsNames[this.channel.name]
      this.$bus.$emit('set-selected-channel', { channelName, settingsId: this.settingsId, isEditing: true })
    },
  },
}
</script>

<style lang="scss" scoped>
.message-container-sections {
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  height: 100%;
  place-content: normal;
}

.message-container-section-bottom {
  display: flex;
  margin: auto 0 auto 0;
  width: 100%;
}

.message-container-section-top {
  min-width: 200px;
  width: max-content;
}

.message-container {
  border: 2px solid $marca-0-l40;
  border-radius: 16px;
  padding: 8px;
  height: 200px;
}
.user-name {
  color: purple;
}
.message-rank {
  font-weight: bold;
  color: $marca-0-l20;
}
.message-rank-number {
  font-weight: bold;
  color: $marca-0-l40;
}
.active-channel {
  border-color: $marca-0-l40;
}
.inactive-channel {
  border-color: $cinza-l20;
}
.channel-card {
  @media (min-width: 1264px) and (max-width: 1440px) {
    max-width: 230px;
  }
}
</style>
